export const INVALID_ACCOUNT_NUMBER = "Invalid account number";
export const INVALID_ACCOUNT_CUSTOMER =
  "Customer with account this account number doesn't exist";
export const ADMIN_ACCOUNT = "0";
export const EOD_MASTER_USER = "eodMasterUser";
